import * as React from 'react'

export default () => (
  <svg width='384' height='267' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <g clipPath='url(#b)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.615 74.386a1 1 0 0 0 .412 1.353l39.137 20.874a1 1 0 1 0 .942-1.765L31.968 73.974a1 1 0 0 0-1.353.412Zm-33.856 72.602a1 1 0 0 0 .663 1.249c1.573.482 4.243.625 7.394.584 3.198-.041 7.032-.275 11.02-.611 7.98-.673 16.634-1.76 22.17-2.556a1 1 0 0 0-.286-1.98c-5.508.793-14.121 1.874-22.051 2.543-3.966.334-7.748.564-10.878.604-3.177.041-5.549-.118-6.783-.496a1 1 0 0 0-1.25.663Zm57.455 30.223a1 1 0 0 1 1.408 1.421l-23.241 23.047a1 1 0 0 1-1.408-1.42l23.241-23.048ZM144.199 5.987a1 1 0 0 0-.441 1.344c.042.084.12.344.18.866.055.49.085 1.118.09 1.86.01 1.48-.078 3.348-.224 5.354-.292 4.008-.808 8.498-1.195 11.408a1 1 0 1 0 1.983.263c.39-2.935.911-7.466 1.206-11.526.148-2.027.24-3.955.23-5.513a20.567 20.567 0 0 0-.103-2.07c-.063-.557-.169-1.121-.382-1.544a1 1 0 0 0-1.344-.442ZM87.862 24.435a1 1 0 1 1 1.876-.694L101.21 54.75a1 1 0 1 1-1.876.694L87.862 24.435Z'
          fill='currentColor'
        />
      </g>
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h384v267H0z' />
      </clipPath>
      <clipPath id='b'>
        <path
          fill='currentColor'
          transform='scale(1 -1) rotate(-45.241 -204.006 -20.222)'
          d='M0 0h94.943v241.206H0z'
        />
      </clipPath>
    </defs>
  </svg>
)
